<template>
	<component v-if="componentData && componentData.acf_fc_layout" :is="componentData.acf_fc_layout" v-bind="componentData" />
</template>

<script>
const Slider = () =>  import('./Slider')
const FullWidthSlider = () => import ('./FullWidthSlider');
const FullWidthImage = () => import('./FullWidthImage');
const BigRedText = () =>  import('./BigRedText')
const WYSIWYG = () =>  import('./WYSIWIG')
const MemberNameText = () =>  import('./Member-NameText')
const Modal = () => import('./Modal')
const Button =() => import('./WordpressButton')
const Expander = () => import('./Expander');
const Tabs = () => import('./Tabs');
const Separator = () => import('./Separator');
const ImageLink = () => import('./ImageLink');
const EmailRequest = () => import('./EmailRequest');

export default {
	name: "WordpressComponent",
	props: ["componentData"],
	components:{
		"slider": Slider,
		"full_width_slider": FullWidthSlider,
		"fullwidthimage": FullWidthImage,
		"big_red_text" : BigRedText,
		"wysiwig" : WYSIWYG,
		"member_name_text": MemberNameText,
		"modal": Modal ,
		"wp_button": Button,
		"expander": Expander,
		"tabs" : Tabs,
		"separator": Separator,
		"image_link": ImageLink,
		"emailrequest": EmailRequest
	}
};
</script>

<style lang="scss" scoped>

</style>
